/* eslint-disable */
export const validateEmail = email => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
export const validateUsername = username => {
	if (/^[a-zA-Z0-9_.-]*$/.test(username) && username.length) { return true } else { return false }
}
export const validatePostalCode = postalCode => /^[0-9]{4}(?:-[0-9]{3})?$/.test(postalCode)

export const validateDate = birthday => {
	if (/^(19|20)\d\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])$/.test(birthday)){
		return true
	}
	return false
}

export const convertDate = birthday => {
	if (/^(0[1-9]|[12][0-9]|3[01])[\- \/.](?:(0[1-9]|1[012])[\- \/.](19|20)[0-9]{2})$/.test(birthday)){
		const temp = birthday.split('/')
		return `${ temp[2]  }-${  temp[1]  }-${  temp[0] }`
	}
	return false
}

export const validateTime = time => /^([0-9][0-9])([:][0-5][0-9])?$/.test(time)



// WEBPACK FOOTER //
// ./src/client/webapp/helpers/validations.js